import React from 'react';
import { motion } from 'framer-motion';
import { Zap, DollarSign, UserCheck, ThumbsUp, MapPin } from 'lucide-react';
const features = [{
  title: 'Fast Dispatch',
  description: 'Same-day and next-day delivery. Order before 10 AM and get it today.',
  icon: Zap
}, {
  title: 'Bulk Pricing',
  description: 'Best pricing in the Seattle-Tacoma area. No hidden fees, transparent quotes.',
  icon: DollarSign
}, {
  title: 'Owner-Operated',
  description: 'Deal directly with the people who care about your project.',
  icon: UserCheck
}, {
  title: 'Easy Ordering',
  description: 'Call, text, or use our instant quote tool. Simple as that.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-16 bg-stone-100 dark:bg-[#333030] transition-colors duration-300 border-y border-stone-200 dark:border-[#2b2929]" id="why-us" data-id="element-1244">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1245">
        {/* Locally Owned intro */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-1246">
          <div className="flex items-center gap-2 mb-3" data-id="element-1247">
            <MapPin className="w-4 h-4 text-brand-orange" data-id="element-1248" />
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest" data-id="element-1249">
              Locally Owned & Operated
            </span>
          </div>
          <p className="text-brand-charcoal/80 dark:text-white/80 text-base sm:text-lg leading-relaxed sm:leading-loose font-sub font-semibold max-w-3xl" data-id="element-1250">
            We're based in the 253 area code and deliver to Pierce County and
            King County daily. No middlemen, no markups from national chains —
            just honest pricing on crushed rock, drain rock, topsoil, bark, and
            recycled aggregates delivered straight to your property.
          </p>
        </motion.div>

        {/* Feature cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1251">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex flex-col items-center text-center px-2" data-id="element-1252">
              <div className="w-10 h-10 bg-brand-dim/10 dark:bg-brand-dim/20 rounded-xl flex items-center justify-center mb-4 border border-brand-dim/20 dark:border-brand-dim/30" data-id="element-1253">
                <feature.icon className="w-5 h-5 text-brand-dim" data-id="element-1254" />
              </div>
              <h3 className="font-heading text-sm font-bold text-brand-charcoal dark:text-white mb-1" data-id="element-1255">
                {feature.title}
              </h3>
              <p className="text-brand-charcoal/60 dark:text-white/60 text-xs leading-relaxed" data-id="element-1256">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}